// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2QKmu","bigColWidth":"Table_bigColWidth__1e86V","biggerColWidth":"Table_biggerColWidth__17afv","row":"Table_row__H-koO","col":"Table_col__1vUG1"};